import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ExaminationContent from "./examinationContent";
import { recordData$ } from "../../reduxStore/selectors/recordSelectors";
import { usersData$ } from "../../reduxStore/selectors/userSelectors";
import { endRecord, createRecordAndGetFirstQuestion } from "../../reduxStore/actions/recordActionsHelper";
import { sessionModeType } from "../../utils/Enum/sessionModeType";

const Section25ExaminationContent = ({ question, section, onEndSession }) => {
    const dispatch = useDispatch();
    const currentRecord = useSelector(recordData$);
    const userData = useSelector(usersData$);

    const [sessionStartTime, setSessionStartTime] = useState(Date.now());

    // Calculate question number within the current set (1-25)
    const getQuestionNumberInSet = () => {
        if (!currentRecord?.currentQuestionIndex) return 1;
        const index = currentRecord.currentQuestionIndex;
        return (index % 25) + 1;
    };

    const handleContinuePractice = () => {

        // End current session
        if (currentRecord?._id) {
            dispatch(endRecord.request({ recordId: currentRecord._id }));
        }

        // Start a new session with counter at 1
        if (userData?.id && section) {
            dispatch(createRecordAndGetFirstQuestion.request({
                recordData: {
                    userId: userData.id,
                    testType: 'SAT Practice',
                    section: section,
                    sessionMode_type: sessionModeType.SECTION_25
                },
                questionRequest: {
                    section: section,
                    userId: userData.id
                }
            }));
        }

        // Reset session tracking
        setSessionStartTime(Date.now());
    };

    const handleEndSession = () => {
        if (onEndSession) {
            onEndSession();
        }
    };

    return (
        <ExaminationContent
            question={question}
            section={section}
            questionNumberOverride={getQuestionNumberInSet()}
            maxQuestionsInSet={25}
            is25QuestionMode={true}
            sessionStartTime={sessionStartTime}
            onCheckpointReached={(action) => {
                if (action === 'continue') {
                    handleContinuePractice();
                } else if (action === 'end') {
                    handleEndSession();
                }
            }}
        />
    );
};

export default Section25ExaminationContent;
